import { Language } from '../../enums/language.enum';
import { findTranslationRecord } from './find-translation-record';

export function findTargetLanguagePath(currentPath: string, targetLanguage: Language): string {
	return findTranslationRecord(currentPath)[targetLanguage];
}
